import { Box, useTheme } from '@mui/material';
import { ReactElement } from 'react';

import { SearchNavigation } from './search-navigation/search-navigation';
import { TopNavigation } from './top-navigation/top-navigation';

export const Header = (): ReactElement => {
    const theme = useTheme();

    return (
        <Box
            pt={{ xs: 0.75, sm: 0 }}
            sx={{ color: theme.palette.common.white, backgroundColor: theme.palette.common.black }}
        >
            <TopNavigation />
            <SearchNavigation />
        </Box>
    );
};
